// extracted by css-extract-rspack-plugin
export default {"hubEditBar":"XyNTI"};